import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  button: {
    borderRadius: 2,
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
    margin: "1vmax",
    padding: "1vmax",
  },
  outline: {
    backgroundColor: "transparent",
    shadowOpacity: 0.1,
    shadowRadius: 15,
    borderWidth: 2,
    borderRadius: 2,
    padding: "1vmax",
    borderColor: "$home_button",
  },
  text: {
    fontSize: "$home_button_text_size",
    fontFamily: "$home_button_text_style",
    textTransform: "uppercase",
    color: "$home_button",
  },
  disabled: {
    opacity: 0.3,
  },
});
